import { Component, OnInit } from '@angular/core';
import { Utility } from '../../../common/utility';
import { FormBuilder } from '@angular/forms';
import { BaseService } from '../../../shared/services/base.service';
import { AppConstants } from '../../../shared/constants/constants';
import * as moment from 'moment';
import { BaseUrl } from '../../../shared/urls/base.url';
import { typeVaccination } from '../admin-vaccine.service';
import { PatientUrl } from '../../../shared/urls/patient.url';
@Component({
  selector: 'app-future-vaccine',
  templateUrl: './future-vaccine.component.html'
})
export class FutureVaccineComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  public appConstants = AppConstants;
  public vaccinationEnum = typeVaccination;
  constructor(
    public utility: Utility,
    private formBuilder: FormBuilder,
    public baseService: BaseService) { }

  ngOnInit() {
    $.fn.dataTable.ext.errMode = 'throw';
    // replace url get future vaccine
    const url = BaseUrl.BASE_URL +
    PatientUrl.PATIENT_GET_VACCINATION + '?typeVaccination=' + this.vaccinationEnum.futureVaccinations;

    // const self = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 15,
      searching: false,
      lengthChange: false,
      retrieve: true,
      serverSide: true,
      processing: true,
      ajax: {
        url: url,
        type: 'GET',
        beforeSend: function (request) {
          request.setRequestHeader('Content-Type', 'application/json');
          request.setRequestHeader('Accept', 'application/json');
          request.setRequestHeader('Authorization', 'bearer ' + BaseService.token);
        }
      },
      columns: [{
        title: 'Administer Date',
        data: 'administeredDate',
        render: function (data, type, row) {
          return moment(data).format('DD MMM YYYY');
        }
      }, {
        title: 'Vaccine',
        data: 'vaccineName'
      }, {
        title: 'Centre',
        data: 'centre'
      },
      ],
      language: {
        emptyTable: 'No vaccine record',
        info: 'Total _TOTAL_ vaccine(s)',
        infoEmpty: 'Total 0 vaccine(s)',
        processing: '<img src="../assets/images/spinner.gif" />'
      }
    };
  }


}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/admin-vaccine/future-vaccine/future-vaccine.component.ts